import {createRouter, createWebHashHistory} from 'vue-router';
import routes from './routes';
import PlaceTokens from "@/utils/constants/PlaceTokens.ts";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const router = createRouter({
  scrollBehavior: () => ({left: 0, top: 0}),
  routes,
  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createWebHashHistory(process.env.VUE_ROUTER_BASE),
});

router.beforeEach((to, from, next) => {
  let tokens = [PlaceTokens.PREFIX_LIST, PlaceTokens.PREFIX_EDIT, PlaceTokens.PREFIX_LAUNCH_REPORT, PlaceTokens.PREFIX_REPORT_Result,
    PlaceTokens.PREFIX_REPORT_List, PlaceTokens.PREFIX_WELCOME, PlaceTokens.WIZARD_VIEW, PlaceTokens.PREFIX_login, PlaceTokens.LAYOUT_EDITOR_VIEW,
    PlaceTokens.REPORT_WIZARD_EDITOR, PlaceTokens.PREFIX_EDIT_FILE].map(l => `/${l}:`)
  if (tokens.some(l => to.fullPath.startsWith(l))) {
    let currentToken = tokens.find(l => to.fullPath.startsWith(l))!;
    const hashParams = to.fullPath.slice(currentToken.length);
    const params = hashParams.split('&').reduce((acc, param) => {
      const [key, value] = param.split('/');
      if (key) acc[key] = value;
      return acc;
    }, {});
    next({
      path: currentToken.substring(0, currentToken.length - 1),
      query: params
    });
  } else {
    next();
  }
});

export default router;
